import { usePageTitle } from '../../hooks/usePageTitle';
import SideBar from '../../components/global/SideBar';
import { useCurrentUser } from '@beholos/holoscommon';
import MembershipTabs from '../../components/membership/MembershipTabs';
import FamilyHub from '../family-hub';

export default function FamilyPlan() {
  usePageTitle('Plan Familiar - Holos');
  const { user } = useCurrentUser();

  return (
    <div className="flex h-[calc(100vh-80px)] w-screen overflow-hidden">
      <div className="hidden md:block md:w-80 lg:w-96 h-full overflow-y-auto">
        <SideBar />
      </div>

      <div className="flex-1 h-full overflow-y-auto bg-gray-200 py-15 px-6">
        <div className="bg-gray-200 p-6 rounded max-w-6xl mx-auto">
          <div className="text-left mb-6">
            <h3 className="text-2xl md:text-4xl mb-3 font-medium font-juana">
              <span>Mi plan</span>
            </h3>
          </div>

          {(user?.hasPlan && user?.isCorporate) && <MembershipTabs />}

          <section className="my-6">
            <FamilyHub />
          </section>
        </div>
      </div>
    </div>
  );
}
